import React from 'react';

import { BaseRouterLinkProps } from './BaseRouterLink';
import { getLinkColor, getLinkFontFamily } from './helpers';
import { StyledHeadingRouterLink } from './StyledHeadingRouterLink';

export type HeadingRouterLinkProps = Omit<BaseRouterLinkProps, 'size'>;

export function HeadingRouterLink({
    children,
    color = 'puntRoad',
    fontFamily = 'heading',
    ...props
}: HeadingRouterLinkProps) {
    return (
        <StyledHeadingRouterLink
            {...props}
            linkColor={getLinkColor(color)}
            linkFontFamily={getLinkFontFamily(fontFamily)}
        >
            {children}
        </StyledHeadingRouterLink>
    );
}
